"use client";
import React, { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";

const Counter = ({ end, suffix, label }) => {
  const [hasStarted, setHasStarted] = useState(false); // Track if counter should start
  const counterRef = useRef(null); // Reference to the counter element

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasStarted(true);
          observer.disconnect(); // Stop observing once it's started
        }
      },
      { threshold: 0.5 } // Adjust this threshold based on when you want it to start (50% visible)
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  return (
    <div className="mb-8 md:mb-0" ref={counterRef}>
      <h2 className="font-bold text-white mb-2">
        {hasStarted ? (
          <CountUp start={0} end={end} duration={3} suffix={suffix} />
        ) : (
          "0"
        )}
      </h2>
      <div className="text-white uppercase font-medium">{label}</div>
    </div>
  );
};

export default Counter;
